var DOCUMENT = typeof document !== 'undefined' ? document : null;
var WINDOW = typeof window !== 'undefined' ? window : null;

export { DOCUMENT, WINDOW };
//# sourceMappingURL=platform.js.map
